const WELLNESS_BY_APPROXIE = "wellness-by-approxie";

interface PrescriptionAvailabilityOptions {
  isDevelopment?: boolean;
}

/**
 * The printable form contains Wellness by ApproXie clinic and prescriber
 * details, so it must remain tenant-restricted outside local development.
 * Local development allows branch-isolated tenants to exercise the real UI.
 */
export function canPrintPrescriptionForTenant(
  tenantSubDomain?: string,
  {
    isDevelopment = process.env.NODE_ENV === "development",
  }: PrescriptionAvailabilityOptions = {},
): boolean {
  if (!tenantSubDomain) return false;

  return (
    isDevelopment ||
    tenantSubDomain === WELLNESS_BY_APPROXIE ||
    tenantSubDomain.startsWith("dev")
  );
}
